export interface Category {
  slug: string;
  name: string;
  description: string;
  icon: string;
  articleCount: number;
}

export const categories: Category[] = [
  {
    slug: 'european-american',
    name: '欧美gay片',
    description: '欧美gay片以高制作水准、丰富题材和大胆表现著称，涵盖从浪漫剧情到硬核动作的各类内容，是全球gay片市场的主力军。',
    icon: 'ri-global-line',
    articleCount: 28,
  },
  {
    slug: 'asian',
    name: '亚洲gay片',
    description: '亚洲gay片涵盖日本、韩国、泰国、台湾等地区的优质内容，以细腻情感表达和独特东方美学风格见长。',
    icon: 'ri-earth-line',
    articleCount: 24,
  },
  {
    slug: 'japanese',
    name: '日本gay片',
    description: '日本gay片产业发达，拥有完整的制片体系和多元化的内容类型，从清新校园到成熟职场，满足不同观众的审美偏好。',
    icon: 'ri-sun-line',
    articleCount: 32,
  },
  {
    slug: 'chinese',
    name: '国产gay片',
    description: '国产gay片近年来发展迅速，涌现出众多优质创作者和作品，以贴近本土文化的内容和真实情感表达赢得观众认可。',
    icon: 'ri-flag-2-line',
    articleCount: 18,
  },
  {
    slug: 'plot-driven',
    name: '剧情gay片',
    description: '剧情gay片注重故事发展和角色塑造，将情感与欲望巧妙融合，为观众带来富有层次的观影体验，适合追求内容深度的观众。',
    icon: 'ri-film-line',
    articleCount: 22,
  },
  {
    slug: 'bear',
    name: '熊族gay片',
    description: '熊族gay片专注于体型健壮、阳刚气质突出的演员与内容，是gay圈中极具特色和忠实受众的细分类型。',
    icon: 'ri-user-heart-line',
    articleCount: 15,
  },
  {
    slug: 'young',
    name: '青年gay片',
    description: '青年gay片以年轻演员和青春活力为主题，风格清新自然，展现当代年轻人的情感世界与生活方式，深受年轻观众喜爱。',
    icon: 'ri-seedling-line',
    articleCount: 26,
  },
  {
    slug: 'classic',
    name: '经典gay片',
    description: '经典gay片收录了gay片发展史上的里程碑式作品，这些影片不仅具有历史价值，至今仍被影迷津津乐道，是了解gay片文化的必看之作。',
    icon: 'ri-award-line',
    articleCount: 12,
  },
];